import script from "./ProductsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsView.vue?vue&type=script&setup=true&lang=js"

import "./ProductsView.vue?vue&type=style&index=0&id=ae279cd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae279cd8"]])

export default __exports__